import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import { languages } from "../constants/languages";

export default class DeleteDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent style={{ width: 350, maxWidth: "97%" }}>
          <DialogContentText>{this.props.description}</DialogContentText>
          {(this.props.errorMessage || "").length > 0 && (
            <DialogContentText style={{ color: "red" }}>
              {this.props.errorMessage}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleDelete}
            variant="contained"
            color={this.props.confirmationShown ? "secondary" : "primary"}
            disabled={this.props.deleteButtonDisabled}
          >
            {this.props.confirmationButtonText || languages.general.delete}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
